export const QRCODE_END_OF_FILE = "[--END--]"